import React from 'react';
import { HOW_IT_WORKS } from '../../mock';

export default function HowItWorks() {
  return (
    <section id="how" className="relative py-28" style={{ background: 'linear-gradient(180deg,#0A0806,#100B07)' }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="reveal max-w-2xl mb-16">
          <p className="eyebrow mb-4">How it works</p>
          <h2 className="font-display text-5xl md:text-6xl text-cream leading-[0.95]">Four steps to <span className="italic text-gold-grad">your song.</span></h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {HOW_IT_WORKS.map((s, i) => (
            <div key={s.n} className="reveal relative" style={{ transitionDelay: `${i * 80}ms` }}>
              <div className="font-display text-6xl text-gold/20 mb-4">{s.n}</div>
              <h3 className="font-display text-2xl text-cream mb-3">{s.title}</h3>
              <p className="text-cream/60 leading-relaxed text-[15px]">{s.body}</p>
              <div className="mt-6 h-px w-full bg-gradient-to-r from-gold/40 to-transparent" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
